<mat-card class="kanban-card" [padding]="8" *ngFor="let item of items; trackBy: trackByStructureId" cdkDrag>
  <!-- Header -->
  <div class="kanban-card-header">
    <div class="row center ver-icon">
      <div class="col link" (click)="selectStructure(item)">
        <div class="row center">
          <div justify="flex-start" class="custom margin sm right">
            {{ item.structureNumber }}
          </div>
          <div justify="flex-end" class="h6">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="col" [flex]="0" *ngIf="isOrderIdPresent(item) || isPublishable(item) || canOverideAndPublish(item)">
        <button class="link" mat-icon-button [matMenuTriggerFor]="actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actions>
          <button mat-menu-item (click)="publish(item)" *ngIf="isPublishable(item)">
            <mat-icon>publish</mat-icon>Publish
          </button>
          <button
            mat-menu-item
            *ngIf="canOverideAndPublish(item) && user._isSuperUser"
            (click)="overrideStructureErrorsConfirm(item)"
          >
            <mat-icon>publish</mat-icon>Override and Publish
          </button>
          <div *ngIf="isOrderIdPresent(item)">
            <button mat-menu-item (click)="rejectConfirm(item)"><mat-icon>delete</mat-icon>Reject</button>
            <button *ngIf="item?.isRejectDelete" mat-menu-item (click)="deleteConfirm(item)">
              <mat-icon>delete_forever</mat-icon>Reject & Delete
            </button>
          </div>
        </mat-menu>
      </div>
    </div>

    <mat-spinner *ngIf="item.queuedForMecs" [diameter]="24"></mat-spinner>
  </div>

  <div class="padding top right bottom left">
    <!-- Assigned User -->
    <div class="row margin bottom center">
      <mat-chip size="small" class="margin right">
        {{ initials(item.lockedBy) }}
      </mat-chip>
      <mat-select [(value)]="item.lockedById" [disabled]="changeUserDisabled(item)">
        <mat-option *ngFor="let user of users" [value]="user.id" (click)="changeUser(item, user.id)">
          <div class="row">
            <div>{{ user.name }}</div>
          </div>
        </mat-option>
      </mat-select>
    </div>

    <div class="row center">
      <span class="custom margin right">Created:</span>
      <span class="label">{{ item.createdOn | date : 'MM/dd/yyyy h:mm a' }}</span>
    </div>
    <div class="row center" *ngIf="item.keySystems[0]?.orderNumber && item.keySystems[0]?.orderNumber !== null">
      <span class="custom margin right">Order Number:</span>
      <span class="label">{{ item.keySystems[0]?.orderNumber }}</span>
      <span
        *ngIf="!isPendingReport(item) && !isCompletedReport(item) && !isFailedReport(item)"
        (click)="generateReport(item, false)"
        class="material-icons-outlined link margin left"
        matTooltip="Order Detail"
      >
        file_download
      </span>
      <span
        *ngIf="isPendingReport(item)"
        (click)="generateReport(item)"
        class="material-icons-outlined link margin left"
        matTooltip="This report is currently generating."
      >
        <mat-spinner
          class="padding right"
          [diameter]="25"
          matTooltip="This report is currently generating."
        ></mat-spinner>
      </span>
      <span
        *ngIf="isCompletedReport(item)"
        (click)="downloadOrderDetailReport(item, item.keySystems[0])"
        class="material-icons-outlined link margin left greenIcon"
        matTooltip="This report can now be downloaded."
      >
        file_download
      </span>
      <span
        *ngIf="isFailedReport(item)"
        (click)="generateReport(item, true)"
        class="material-icons-outlined link margin left redIcon"
        matTooltip="An error has occured with this report. Click here to regenerate. If a problem continues, please contact support."
      >
        sync_problem
      </span>
    </div>

    <div
      padding="8px 0 0 0"
      class="row center margin top custom toggle-button"
      (click)="item.showSystems = !item.showSystems"
    >
      <!--Update the icon from phx to mat-->
      <mat-icon class="padding right">key</mat-icon>
      0/{{ item?.keySystems?.length }}
    </div>

    <div class="key-systems-wrapper" *ngIf="item.showSystems">
      <div class="margin bottom center key-system" *ngFor="let keySystem of item.keySystems">
        <div (click)="selectKeySystem(item, keySystem)" class="tmk-name">
          <div>{{ keySystem.topMasterKeyName }}</div>
        </div>
        <div *ngIf="keySystem.statusId !== 7" class="status">
          <span class="custom margin right">Status:</span>
          <div
            *ngIf="keySystem.statusId !== 2 && keySystem.statusId !== 3"
            class="circle"
            [ngClass]="{
              yellow: keySystem.statusId === 6 || keySystem.statusId === 7 || keySystem.statusId === 11,
              red: keySystem.statusId === 8 || keySystem.statusId === 9 || keySystem.statusId === 12,
              green: keySystem.statusId === 10 || keySystem.statusId === 13
            }"
          ></div>
          <!--Update the icon from phx to mat-->
          <mat-icon class="loading" *ngIf="keySystem.statusId === 2">clock</mat-icon>
          <mat-spinner class="loading" *ngIf="keySystem.statusId === 3" [diameter]="14"></mat-spinner>

          <span class="label">{{ keySystem.status }}</span>

          <div class="col" [flex]="0">
            <span
              class="material-icons-outlined link margin left"
              *ngIf="keySystem.statusId === 9 && user._isSuperUser"
              (click)="overrideKeySystemErrorsConfirm(item.id, keySystem.id, keySystem.topMasterKeyName)"
              matTooltip="Override"
            >
              running_with_errors
            </span>
          </div>
          <div class="col" [flex]="0">
            <span
              (click)="downloadReport(item, keySystem)"
              *ngIf="keySystem.statusId === 9"
              class="material-icons-outlined link margin left"
              matTooltip="Download Error Report"
            >
              file_download
            </span>
            <!-- TODO: Takeoff Report -->
          </div>
        </div>
        <div *ngIf="keySystem.statusId === 7" class="col grow">
          <mat-progress-bar
            color="primary"
            mode="determinate"
            [value]="keySystem.mecsProgressPercentage"
          ></mat-progress-bar>
          <div class="progress-bar-message overline color-brand">{{ keySystem.mecsProgressPercentage }}%</div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
